// extracted by mini-css-extract-plugin
module.exports = {"container":"_2sAtdoia9c7qICck1dhYP-"};